import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Typography } from '@material-ui/core'

import { HelpFindModal } from 'src/common'
import { useMutationHelpSearchProject } from '../common/project-mutations/use-mutation-help-search-projects'
import { useHelpFindProjectStyles } from './help-find-project.styles'
import { TranslationDictionary } from '@plandi/common'

export type PopupFormDataType = {
  name: string
  email: string
  message: string
}

type HelpFindProjectProps = {
  translate?: TranslationDictionary['data']
}

export const HelpFindProject: React.FC<HelpFindProjectProps> = ({
  translate
}) => {
  const [modalOpened, setModalOpened] = useState<boolean>(false)
  const sendSearchHelpRequestMutation = useMutationHelpSearchProject(translate)
  const classes = useHelpFindProjectStyles()

  const initialValues: PopupFormDataType = {
    email: '',
    name: '',
    message: ''
  }
  const modalText =
    translate?.shop['projects-page']['not-found']['help-find-desc']

  const sendHelpRequest = (formData: PopupFormDataType): void => {
    sendSearchHelpRequestMutation.mutate({
      sender: formData.email,
      name: formData.name,
      message: formData.message
    })
    setModalOpened(false)
  }

  return (
    <div>
      <Typography
        color="primary"
        onClick={() => setModalOpened(true)}
        className={classes.openModalButton}
      >
        {translate?.shop['projects-page']['not-found']['button']}
      </Typography>
      {modalOpened && (
        <Formik
          onSubmit={sendHelpRequest}
          initialValues={initialValues}
          validationSchema={Yup.object({
            name: Yup.string().required(translate?.['this-field-required']),
            email: Yup.string().required(translate?.['this-field-required']),
            message: Yup.string().required(translate?.['this-field-required'])
          })}
        >
          <Form>
            <HelpFindModal
              title={translate?.shop['projects-page']['not-found']['help-find']}
              text={modalText}
              handleCancel={() => setModalOpened(false)}
              initialValues={initialValues}
            />
          </Form>
        </Formik>
      )}
    </div>
  )
}
